import {Helmet} from '@dr.pogodin/react-helmet';

import {useEffect} from 'react';

import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';
import {getCustomTenantCatalogue, getVehicleMakes, useThunkDispatch} from '@dms/teas';

import {useBoolean} from 'shared/web';

import {TopMakes} from './components/TopMakes';

export function VehicleTopMakes() {
  const dispatch = useThunkDispatch();

  const [isLoading, startLoading, stopLoading] = useBoolean(false);

  useEffect(
    function loadTopMakesData() {
      startLoading();
      Promise.all([
        dispatch(getCustomTenantCatalogue.action({})),
        dispatch(getVehicleMakes.action({vehicleType: 'VEHICLETYPE_PASSENGER_CAR'})),
      ]).finally(() => {
        stopLoading();
      });
    },
    [dispatch, startLoading, stopLoading]
  );

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.topMakesTitle'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        isLoading={isLoading}
        header={{title: i18n.t('page.salesSettings.labels.topMakesTitle')}}
        description={i18n.t('page.salesSettings.labels.topMakesDescription')}
        data-testid="integrations-top-makes-settings-modal"
      >
        <TopMakes />
      </SettingsTemplate>
    </>
  );
}
